import React from "react"; // import css for animation

const CircularLoader = ({ radius = 20, color = "#d32f2f", strokeWidth = 4 }) => {
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = 2 * Math.PI * normalizedRadius;

  return (
    <svg
      height={radius * 2}
      width={radius * 2}
      className="circular-loader"
    >
      <circle
        stroke={color}
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={circumference * 0.75} // show only part of circle
        r={normalizedRadius}
        cx={radius}
        cy={radius}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CircularLoader;
